import { checkIsDefined as i, logger as t } from "./server-entry-83d3751d.js";
function a() {
  var o;
  return typeof process != "undefined" && i((o = process == null ? void 0 : process.versions) == null ? void 0 : o.node);
}
const d = ({
  shouldLogWarning: o
}) => {
  var e;
  if (!a())
    return !1;
  const s = process.arch === "arm64", n = process.version.startsWith("v20"), r = (e = process.env.NODE_OPTIONS) == null ? void 0 : e.includes("--no-node-snapshot");
  return s && n && !r ? (o && t.log("Skipping usage of `isolated-vm` to avoid crashes in Node v20 on an arm64 machine.\n    If you would like to use the `isolated-vm` package on this machine, please provide the `NODE_OPTIONS=--no-node-snapshot` config to your Node process.\n    See https://github.com/BuilderIO/builder/blob/main/packages/sdks/README.md#node-v20--m1-macs-apple-silicon-support for more information.\n    "), !0) : !1;
};
export {
  d as shouldForceBrowserRuntimeInNode
};
